import { XCircleIcon } from '@heroicons/react/20/solid';

interface CriteriaRowProps {
  label: string;
  value: string;
}

export function NoPriceSummaryFoundContentCriteriaRow({
  label,
  value,
}: CriteriaRowProps) {
  return (
    <div className="flex items-center justify-between rounded-md border border-red-200 bg-red-50 px-4 py-3">
      <div className="flex items-center gap-2">
        <XCircleIcon className="h-5 w-5 flex-shrink-0 text-red-500" />
        <span className="text-sm font-medium text-gray-900">{label}</span>
      </div>
      <span className="text-sm font-medium text-red-600">{value}</span>
    </div>
  );
}
